import { useNavigate } from 'react-router-dom'
import { LuLogOut } from 'react-icons/lu'
import { Button } from './LogoutBtn.styled'

function LogoutBtn() {
   const navigate = useNavigate()
   const logoutClick = () => {
      window.localStorage.removeItem("token")
      navigate('/')
   }
   return (
      <Button onClick={() => logoutClick()}>
         <LuLogOut size={19} />
         Вийти
      </Button>
   )
}

export default LogoutBtn
